import Collapse from 'bootstrap/js/dist/collapse';
import Tab from 'bootstrap/js/dist/tab';
import Dropdown from 'bootstrap/js/dist/dropdown';
import Modal from 'bootstrap/js/dist/modal';
import hcOffcanvasNav from 'hc-offcanvas-nav';
import Rellax from "rellax"
import AOS from "aos"
import { lazyloadVideoElement, lazyloadiFrameElement, backgroundImageLazyLoad } from './utilities/lazyload';
import { navigation, bodyOverlay, navigationFunctions } from './components/nav';
// import { contactBar } from './components/contactBar';
import { initSwiper, initSwiperWoo, galleryWithThumbnails } from './components/sliders';
import initDownloadsPage from './pages/downloads-page';
import initNewsResultsPage from './pages/news-page';
import googleMaps from './components/map';
import filters from './filters/filters';
import qtyControls from './components/qtyControls';

//* Animation libraries
const rellax = new Rellax('.rellax');
// For AOS to work we have also included the CSS in the header.php file.
AOS.init({
	duration: 400
}); 
//*

$(function () {
	// Utilities
	backgroundImageLazyLoad();
	lazyloadiFrameElement();
	lazyloadVideoElement();

	// Navigation
	navigationFunctions(navigation);
	bodyOverlay();

	// Componenets
	//contactBar();

	//Sliders
	initSwiper();
	//initSwiperWoo();
	galleryWithThumbnails();
	// Google Maps
	googleMaps();
	
	initDownloadsPage();
	initNewsResultsPage();

	qtyControls();

});
